import { z } from "zod";

export const ASSET_TYPES = ["VEHICLE", "PROPERTY"] as const;
export type AssetType = (typeof ASSET_TYPES)[number];

export const ASSET_STATUSES = [
  "AVAILABLE",
  "RESERVED",
  "SOLD",
  "LEASED",
  "RENTED",
  "MAINTENANCE",
  "INACTIVE",
] as const;
export type AssetStatus = (typeof ASSET_STATUSES)[number];

export const AGREEMENT_TYPES = ["VEHICLE_SALE", "PROPERTY_LEASE", "VEHICLE_RENTAL"] as const;
export type AgreementType = (typeof AGREEMENT_TYPES)[number];

export const AGREEMENT_STATUSES = [
  "DRAFT",
  "AWAITING_SIGNATURE",
  "ACTIVE",
  "OVERDUE",
  "SUSPENDED",
  "COMPLETED",
  "TERMINATED",
  "CANCELLED",
] as const;
export type AgreementStatus = (typeof AGREEMENT_STATUSES)[number];

export const vehicleInputSchema = z.object({
  assetCode: z.string().min(1),
  make: z.string().min(1),
  model: z.string().min(1),
  manufactureYear: z.number().int().min(1900).max(2200),
  modelYear: z.number().int().min(1900).max(2200),
  color: z.string().min(1),
  plate: z.string().min(7).max(8).optional(),
  mileage: z.number().int().nonnegative().default(0),
  usageType: z.enum(["STOCK", "PRIVATE", "RIDE_HAILING", "OTHER"]),
});

export const propertyInputSchema = z.object({
  assetCode: z.string().min(1),
  propertyType: z.enum(["HOUSE", "APARTMENT", "COMMERCIAL", "LAND", "WAREHOUSE", "OTHER"]),
  street: z.string().min(1),
  number: z.string().optional(),
  neighborhood: z.string().min(1),
  city: z.string().min(1),
  state: z.string().length(2),
  postalCode: z.string().optional(),
  bedrooms: z.number().int().nonnegative().optional(),
  parkingSpaces: z.number().int().nonnegative().optional(),
});

export type VehicleInput = z.infer<typeof vehicleInputSchema>;
export type PropertyInput = z.infer<typeof propertyInputSchema>;
